import { Insight } from '../office';
import { reportsIntelApi } from '@verlo/shared/services/api';

/**
 * A topic read (products, staff, sales mix, trading window) — `POST /reports/insight`.
 * The `Insight` piece draws it and decides whether to show at all; this only says which
 * topic and what the read is for.
 */
export const VerloInsightPanel = ({ topic, range = 'last_30', label, hint, testid }) => (
  <Insight
    key={`${topic}:${range}`}
    read={() => reportsIntelApi.verloInsight(topic, range)}
    headline={label}
    purpose={hint}
    testId={testid || `insight-${topic}`}
  />
);

export default VerloInsightPanel;
